





















import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class ResultHeader extends Vue {
  public url = "./";
  public min = true;

  constructor() {
    super();
    if (this.$store.getters.answers) {
      this.url +=
        "?answers=" + JSON.stringify(this.$store.getters.answers.toJson());
    }
  }
  @Emit("openSharingMenu")
  openSharingMenu() {
    this.min = true;
    return;
  }
}
